import { useTranslation } from 'next-i18next';
import { ErrorBoundaryFallback } from '@/components';
import { EmptyListState } from '@/shared/components/itemList/EmptyListState';
import { InfiniteListView } from '@/shared/components/itemList/InfiniteListView';
import { FolderCard } from '@/shared/features/quiz-folder';
import { useSearchQuizQuery } from '@/shared/quizList/hooks/useSearchQuizQuery';
import { useUserFolderList } from '../hooks/useUserFolderList';

/** 이 목록의 카드가 이벤트에 싣는 자리. */
const PLACE = 'user_profile_folder_list';

/**
 * 남의 공개 폴더 전체. 내 폴더 전체 페이지(`/myquiz/folders`)와 같은 목록에서 `새 폴더` 카드·카드 메뉴만 뺐다.
 */
export const UserFolderList = ({
  userHashId
}: {
  userHashId: string;
}) => {
  const {
    t
  } = useTranslation(['common']);
  const {
    searchText
  } = useSearchQuizQuery();
  const {
    folders,
    isLoading,
    isError,
    hasNextPage,
    fetchNextPage,
    isFetchingNextPage
  } = useUserFolderList(userHashId);
  return <InfiniteListView items={folders} isLoading={isLoading} isError={isError} hasNextPage={hasNextPage} fetchNextPage={fetchNextPage} isFetchingNextPage={isFetchingNextPage} renderItem={folder => <FolderCard key={folder.id} folder={folder} place={PLACE} href={`/folder/${folder.id}`} />} EmptyComponent={
  // 남의 목록이라 권할 행동(만들기 등)이 없다 — 설명·버튼 없이 제목만 둔다.
  <EmptyListState keyword={searchText} title={searchText ? t('common:quizList.empty.bySearch') : t('common:folder.profile.empty')} />} ErrorComponent={<ErrorBoundaryFallback />} LoadingComponent={null} data-sentry-element="InfiniteListView" data-sentry-component="UserFolderList" data-sentry-source-file="UserFolderList.tsx" />;
};